import { IKeyValue } from "motw_core/Entity/IKeyValue";
import * as React from "react";
import { Emotion } from "source/app/domain/Emotions/Emotion";
import { IsKeyValueExpired } from "source/app/infrastructure/Data/KeyValues/IsKeyValueExpired";
import { ExpiredKeyValueIcon } from "source/app/presentation/Shared/KeyValues/ExpiredKeyValueIcon";

export function ActiveEmotionDisplayCharacter({
    keyValue,
    emotion,
    isSaving,
}: {
    keyValue: IKeyValue;
    emotion: Emotion;
    isSaving: boolean;
}) {
    if (!isSaving && IsKeyValueExpired(keyValue)) {
        return <ExpiredKeyValueIcon />;
    }

    const displayedCharacter = isSaving ? "⟳" : emotion.character;

    return (
            <span
                id={target_activeEmotionDisplayCharacter}
                aria-label={isSaving ? "Saving emotion" : emotion.character}
                style={{
                    position: `relative`,
                    display: `inline-grid`,
                    placeItems: `center`,
                    lineHeight: 1,
                }}
            >
                <span
                    aria-hidden="true"
                    style={{
                        gridArea: `1 / 1`,
                        visibility: `hidden`,
                        color: `transparent`,
                        textShadow: `none`,
                    }}
                >
                    {emotion.character}
                </span>
                <span
                    aria-hidden="true"
                    style={{
                        gridArea: `1 / 1`,
                        transform: `translate(0.58px, 0.78px)`,
                        color: `#674316`,
                        WebkitTextStroke: `0.36px rgba(43, 27, 10, 0.74)`,
                        textShadow: `0 1px 1px rgba(21, 13, 8, 0.52)`,
                    }}
                >
                    {displayedCharacter}
                </span>
                <span
                    aria-hidden="true"
                    style={{
                        gridArea: `1 / 1`,
                        zIndex: 1,
                        color: `#c99745`,
                        WebkitTextStroke: `0.34px rgba(84, 52, 17, 0.68)`,
                        textShadow:
                            `0 -1px 0 rgba(255, 238, 190, 0.68), ` +
                            `0 1px 0 rgba(72, 45, 15, 0.62), ` +
                            `0 2px 2px rgba(35, 22, 12, 0.36)`,
                    }}
                >
                    {displayedCharacter}
                </span>
                <span
                    aria-hidden="true"
                    style={{
                        gridArea: `1 / 1`,
                        zIndex: 2,
                        transform: `translateY(-0.95px)`,
                        color: `rgba(255, 239, 193, 0.54)`,
                        WebkitTextStroke: `0.12px rgba(255, 248, 220, 0.24)`,
                        clipPath: `inset(0 0 62% 0)`,
                    }}
                >
                    {displayedCharacter}
                </span>
            </span>
    );
}

export const target_activeEmotionDisplayCharacter =
    "target_activeEmotionDisplayCharacter";
